import { render, staticRenderFns } from "./_ModifyRecycleDisposalReportMethod.vue?vue&type=template&id=71945c6d&"
import script from "./_ModifyRecycleDisposalReportMethod.vue?vue&type=script&lang=js&"
export * from "./_ModifyRecycleDisposalReportMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports